var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1527 48.0466C34.9873 45.8033 34.0306 43.2314 32.0158 42.3022C30.0011 41.373 27.6913 42.4383 26.8568 44.6816C26.0222 46.9249 26.979 49.4967 28.9937 50.4259C31.0084 51.3551 33.3182 50.2899 34.1527 48.0466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1555 37.4945C43.2179 35.9496 42.9563 33.7249 41.5608 32.542C38.762 30.1583 35.4161 28.7723 31.88 28.534C27.1783 28.225 22.6352 29.973 19.1069 33.4601C17.7987 34.7578 17.6798 36.9913 18.8453 38.448C19.4716 39.2337 20.3438 39.631 21.2159 39.631C21.9612 39.631 22.7145 39.3396 23.325 38.7393C25.5846 36.5058 28.4944 35.3758 31.5073 35.5788C33.7749 35.7289 35.9156 36.6117 37.7075 38.139C39.1029 39.3308 41.093 39.0395 42.1555 37.4945Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9629 28.1704C52.1284 26.7137 52.0174 24.4891 50.7171 23.1825C45.2067 17.6914 38.0947 14.6633 30.6894 14.6633C23.0779 14.6633 15.8232 17.8326 10.2494 23.5974C8.96493 24.9216 8.89358 27.1552 10.0829 28.5853C10.7092 29.3357 11.5576 29.7153 12.406 29.7153C13.175 29.7153 13.952 29.4063 14.5626 28.7707C18.955 24.2242 24.6874 21.7258 30.6894 21.7258C36.5328 21.7258 42.1383 24.1094 46.4912 28.4441C47.7915 29.7506 49.7895 29.6182 50.9629 28.1704Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.69 0C19.59 0 9.04486 4.67892 0.98937 13.1628C-0.279211 14.5046 -0.334712 16.7382 0.862512 18.1595C1.48887 18.8922 2.32931 19.263 3.16974 19.263C3.95468 19.263 4.73962 18.9452 5.35012 18.3008C12.2242 11.0528 21.2233 7.06252 30.69 7.06252C39.9824 7.06252 48.8545 10.9204 55.6811 17.93C56.9655 19.2542 58.9715 19.1571 60.1608 17.7269C61.3501 16.2968 61.2629 14.0544 59.9784 12.739C51.9784 4.52001 41.5761 0 30.69 0Z",
    fill: "#F26829"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7902 10.4773L35.8003 10.4166V10.355C35.8003 6.76016 33.3676 3.59229 30.0818 3.59229C26.7959 3.59229 24.3633 6.76016 24.3633 10.355V10.4166L24.3733 10.4773L27.8129 31.2908C27.8129 31.2908 27.8129 31.2908 27.8129 31.2908C28.0315 32.6143 28.9854 33.4353 30.0815 33.4353C31.1776 33.4353 32.1315 32.6143 32.3501 31.2908C32.3501 31.2908 32.3501 31.2908 32.3501 31.2908L35.7902 10.4773Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3014 48.0484C32.7182 48.0484 34.4465 45.7329 34.4465 43.1897C34.4465 40.6466 32.7182 38.3311 30.3014 38.3311C27.8846 38.3311 26.1562 40.6466 26.1562 43.1897C26.1562 45.7329 27.8846 48.0484 30.3014 48.0484Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.abbbed3476ddc07e73c4dac0c315d878.svg";
export { ForwardRef as ReactComponent };